<template>
    <div class="fileNav_box">
        <el-scrollbar>
            <div class="fileNav_content">
                <div class="fileNav_fileList" v-if="!loading && fileList.length > 0">
                    <div class="fileNav_fileItem" v-for="item,index of fileList" :key="index" @click="toGetDataDtlFunc(item)">
                        <el-image style="height: 20px;margin-right: 6px;" :src="filterName[item[dataKey + '_suffix'] || 'txt']" :fit="'cover'" />
                        {{item[dataKey + '_name']}}
                    </div>
                </div>
                <div class="fileNav_fileList_empty" v-else-if="!loading && fileList.length == 0">
                     暂无文件
                </div>
                <div class="fileNav_linkFile_btn" v-if="auth == 'EDIT'" @click="openLinkComFunc()">
                    <i class="iconfont icon-lianjie"></i>
                    关联文件
                </div>
            </div>
        </el-scrollbar>
        <elementSelector 
            v-model="elementSet.value"
            v-model:dialogFlag="elementSet.flag"
            :group="5"
            :isMulti="true"
            @selectFunc="selectFunc" 
        >
        </elementSelector>
        <previewPortal v-model="previewSet.flag" :preViewIndex="previewSet.index" :preViewList="previewSet.fileList"></previewPortal>
        <el-dialog
            v-if="previewSet.cflag"
            v-model="previewSet.cflag"
            :title="previewSet.data[dataKey+'_name'] || '文档详情'"
            :close-on-click-modal="false"
            fullscreen
            :close-on-press-escape="false"
            :before-close="beforeCloseFunc"
        >   
            <div class="manageEleDtlFw_c">
                    <qs3sparroweditor v-model="previewSet.data[dataKey + '_content']" 
                        :key="previewSet.data[dataKey + '_id']"
                        :auth="'READONLY'"
                        :outputOps="true"
                    >
                    </qs3sparroweditor>
            </div>
        </el-dialog>
    </div>
</template>
      
<script>
import { defineAsyncComponent } from 'vue';
const previewPortal = defineAsyncComponent(()=>import('qs3_pc_common/src/preview/previewPortal.vue'))
import elementSelector from '../../flowSetConfig/pageSet/common/elementSelector.vue'
import qs3sparroweditor from "qs3_sparroweditor"
export default {
    components:{
        elementSelector,
        previewPortal,
        qs3sparroweditor
    },
    data() {
        return {
            loading:false,
            fileIds:[],
            fileList:[],
            elementSet:{
                flag:false,
                nodeType:null,
                group:null,
                eleObj:{},
            },
            filterName:{
                11:require('@img/know/noe.png'),
                12:require('@img/know/know.png'),
                'doc':require('@img/know/doc.png'),
                'txt':require('@img/know/noe.png'),
                'docx':require('@img/know/doc.png'),
                'xlsx':require('@img/know/xls.png'),
                'xls':require('@img/know/xls.png'),
                'xlsm':require('@img/know/xls.png'),
                'ppt':require('@img/know/ppt.png'),
                'pdf':require('@img/know/pdf.png'),
                'mp3':require('@img/know/mp3.png'),
                'mp4':require('@img/know/mp4.png'),
                'avi':require('@img/know/mp4.png'),
                'zip':require('@img/know/zip.png'),
                'rar':require('@img/know/zip.png'),
                'jpg':require('@img/know/img.png'),
                'png':require('@img/know/img.png'),
                'gif':require('@img/know/img.png'),
                'jpeg':require('@img/know/img.png'),
            },
            previewSet:{
                flag:false,
                cflag:false,
                data:{},
                index:0,
                fileList:[]
            },
        }
    },
    props:{
        modelValue:{
            default: function() {
                return [];
            }
        },  
        keyEleType:{
            type: Number,
            default: function() {
                return 5;
            }
        },  
        bvId:{
            type: String,
            default: function() {
                return '';
            }
        },  
        dataKey:{
            type: String,
            default: function() {
                return 'bfp';
            }
        },  
        mode:{
            type: String,
            default: function() {
                return 'list';
            }
        },  
        auth:{
            type: String,
            default: function() {
                return 'EDIT';
            }
        },  
        dtlApi:{
            type: String,
            default: function() {
                return '';
            }
        },  
    },
    watch:{
        modelValue: {
            handler(newVal) {
                if(newVal){
                    if(this.mode == 'list'){
                        if(typeof newVal == 'string'){
                            this.fileIds = JSON.parse(newVal)
                        }
                        else{
                            this.fileIds = newVal
                        }
                    }
                    if(this.mode == 'objectList'){
                        this.fileIds = Object.values(newVal).reduce((res = [],item)=>{
                            res.push(item[this.dataKey + '_id'])
                            return res
                        },[])
                    }
                }
                else{
                    this.fileIds = []
                }
                this.queryKeyEleByIds()
            },
            deep: true,
            immediate: true
        }, 
    },
    mounted() {
        
    },
    methods: {
        queryKeyEleByIds(){
            if(this.fileIds.length > 0){
                this.$http.post(this.$api.newBpa.queryKeyEleByIds, {
                    'keyEleType':this.keyEleType,
                    'keyEleIds':this.fileIds
                }).then(res => {
                    this.fileList = res.payload
                })
            }
            else{
                this.fileList = []
            }
        },
        openLinkComFunc(){
            this.elementSet.value = this.fileIds
            this.elementSet.flag = true
        },
        selectFunc(values){
            this.fileIds = values
            this.$emit('update:modelValue',this.fileIds)
            this.$emit('updateValue')
        },
        preViewFile(fileId,fileName,fileType){
            let obj = {
                file_name:(fileName||'-' )+'.'+fileType,
                file_id:fileId,
            }
            this.previewSet.index = 0
            this.previewSet.fileList = [obj]
            this.previewSet.flag = true
        },
        toEditWordFunc(data){
            this.previewSet.data = {
                ...data,
                [this.dataKey + '_content']:JSON.parse(data[this.dataKey + '_content']) ||'[]'
            }
            this.previewSet.cflag = true
        },
        toGetDataDtlFunc(item){
            this.$http.post(this.dtlApi || this.$api.newBpa.queryBfFilePageDtl,{
                [this.dataKey + '_id']:item[this.dataKey + '_id']
            }).then((res)=>{
                let dataObj = res.payload || {}
                if(dataObj[this.dataKey + '_type'] == 10){
                    let content = JSON.parse(dataObj[this.dataKey + '_content'])
                    this.preViewFile(content.fileId,dataObj[this.dataKey + '_name'],content.fileType)
                }
                else{
                    this.toEditWordFunc(dataObj)
                }
            })
        }
    }
}
</script>
<style lang="scss" scoped>
.fileNav_box{
    width: 100%;
    height: 100%;
    .fileNav_content{
        width: 100%;
        box-sizing: border-box;
        .fileNav_fileList{
            .fileNav_fileItem{
                display: flex;
                align-items: center;
                padding: 8px 20px;
                cursor: pointer;
                transition: all 0.25s;
                background-color: #fff;
                &:hover{
                    background-color: var(--lightColor)
                }
            }
        }
        .fileNav_fileList_empty{
            width: 100%;
            font-size: 13px;
            color: #909099;
            padding: 20px 15px;
            box-sizing: border-box;
        }
        .fileNav_linkFile_btn{
            display: flex;
            align-items: center;
            color: #909099;
            margin-top: 12px;
            cursor: pointer;
            padding: 0 20px;
            i{
                margin-right: 6px;
                font-size: 14px;
            }
        }
    }
}
</style>